import { axios } from "@/main";

export default class PerformanceResource {
    async get(name, startDate, endDate, page, reviewed, extraFilter) {
        const request = this.getRequest(name, startDate, endDate, page, reviewed, extraFilter)

        return await axios.get(process.env.VUE_APP_REST_API + 'performance/' + request);
    }

    getRequest(name, startDate, endDate, page, reviewed, extraFilter) {
        let dateRange = '';
        if (reviewed) {
            dateRange = `filter[reviewed_date_range]=${startDate},${endDate}`;
        } else {
            dateRange = `filter[transaction_date_range]=${startDate},${endDate}`;
        }

        let query = `${name}?${dateRange}&page=${page}`;

        if (extraFilter) {
            if (
                extraFilter.hasOwnProperty("chosenAdvertiserNamesFilter") &&
                extraFilter.chosenAdvertiserNamesFilter
            ) {
                query =
                    query +
                    `&filter[program_name]=${
                        extraFilter.chosenAdvertiserNamesFilter
                    }`;
            }
            if (
                extraFilter.hasOwnProperty("website") &&
                extraFilter.website
            ) {
                query =
                    query +
                    `&filter[website_ids]=${
                        extraFilter.website
                    }`;
            }
        }
        if (
            reviewed
        ) {
            query =
                query +
                `&reviewed=${
                    reviewed
                }`;
        }

        return query;
    }

    async getAdvertiserNames(affiliateNetworkId, dateFrom) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `performance/advertiser-names?affiliate_network_id=${affiliateNetworkId}&date_from=${dateFrom}`
        );
    }
}
